<div class="select-account-form-wrapper">
  <i2g-form-master *ngIf="form" class="form" [form]="form">
    <div *ngFor="let account of accounts; let i = index" class="form-row">
      <i2g-radio-field
        e2eId="account-{{ i }}"
        fieldId="account-{{ i }}"
        group="account"
        [label]="account.companyName || defaultCompanyName"
        [value]="account.accountId"
        [fieldControl]="selectAccount"
      >
      </i2g-radio-field>
    </div>
  </i2g-form-master>

  <button
    i2gButton
    buttonStyle="emphasis"
    [disabled]="form.invalid"
    (click)="submit()"
  >
    {{ 'ACTION.SELECT_ACCOUNT' | translate }}
  </button>
</div>
